var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('v-chip',{attrs:{"small":"","color":"primary"},on:{"click":function($event){return _vm.$emit('click')}}},[_c('v-icon',{attrs:{"left":"","small":""}},[_vm._v("add")]),_vm._v(" Add ")],1)],1)}
var staticRenderFns = []

export { render, staticRenderFns }